import { render, staticRenderFns } from "./PropListGroup.vue?vue&type=template&id=c129a4e6&scoped=true"
import script from "./PropListGroup.vue?vue&type=script&lang=js"
export * from "./PropListGroup.vue?vue&type=script&lang=js"
import style0 from "./PropList.scss?vue&type=style&index=0&id=c129a4e6&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c129a4e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VListGroup,VListItem,VListItemContent,VListItemTitle})
